import React from 'react';
import { observer } from 'mobx-react';
import { AuthenticationTypeFieldsProps } from 'areas/administration/authentication/types';
import { OAuth2Fields } from 'areas/administration/authentication/oauth2/components/oauth2-fields/oauth2Fields';
import { OAuth2FieldsStore } from 'areas/administration/authentication/oauth2/components/oauth2-fields/oauth2FieldsStore';
import { SmtpFields } from 'areas/administration/authentication/smtp/components/smtp-fields/smtpFields';
import { SmtpFieldsStore } from 'areas/administration/authentication/smtp/components/smtp-fields/smtpFieldsStore';
import { SimpleFields } from 'areas/administration/authentication/components/simple-fields/simpleFields';
import { SimpleFieldsStore } from 'areas/administration/authentication/components/simple-fields/simpleFieldsStore';

export const AuthenticationTypeFields = observer(({ store }: AuthenticationTypeFieldsProps) => {
	if (store instanceof OAuth2FieldsStore) {
		return <OAuth2Fields store={store} />;
	}

	if (store instanceof SmtpFieldsStore) {
		return <SmtpFields store={store} />;
	}

	if (store instanceof SimpleFieldsStore) {
		return <SimpleFields store={store} />;
	}

	return null;
});
